import * as Config from '../../../config';
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import './Input.css';

import { FormContext } from '../../../contexts/form-context';

function InputSelect({
  name, label, value, placeholder = null, style,
  containerClassName, labelClassName, selectClassName,
  setValueExternal = null, options = []
}) {
  const { data, set } = useContext(FormContext);
  const [val, setVal] = useState(value);
  const setValue = (e) => {
    setVal(e.target.value);
    const form = { ...data };
    form[name] = e.target.value;
    set({...form});
    if (setValueExternal) { setValueExternal(e.target.value) }
  }

  return (
    <div className={containerClassName} style={{ ...style }}>
      <span className={labelClassName}>{ label }</span>
      <select style={{ color: Config.TYPE_SECONDARY }} onChange={setValue} placeholder={placeholder} value={val} name={name} className={selectClassName}>
        { (value === '' || !value) ? <option value="" disabled selected>{placeholder}</option> : null }
        { options.map( (x,i) => <option key={`option-select-${i}`} value={x}>{x}</option>) }
      </select>
    </div>
  )
}

InputSelect.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  selectClassName: PropTypes.string,
  setValueExternal: PropTypes.func,
  options: PropTypes.array
}

export default InputSelect;
